/** @format */

import { fromJS } from 'immutable';

const INITIAL_STATE = fromJS({
  isShowing: false
});

export default function deleteConfigurationReducer(
  state = INITIAL_STATE,
  action
) {
  switch (action.type) {
    case 'SHOW_CREATE_NEW_CONFIGURATION_MODAL': {
      return state.set('isShowing', true);
    }
    case 'HIDE_CREATE_NEW_CONFIGURATION_MODAL': {
      return state.set('isShowing', false);
    }
    default: {
      return state;
    }
  }
}
